import { useEffect } from 'react';
import { mdiClose } from '@mdi/js';
import Icon from '@mdi/react';
import { Modal, ModalBody, Table } from 'reactstrap';
import moment from 'moment';
import { toast } from 'react-toastify';
import { useQuery } from '@tanstack/react-query';
import { fetchApproverDetails } from '../../../store/apis/travelRequestService';
import { Messages } from '../../../common/messages';

function ViewApproversModal({ isOpen, toggle, requestNo, revisionNo }) {
  // Add dependency tracking for parameters
  const isParamsReady = Boolean(requestNo && revisionNo && isOpen);

  const { data, isLoading, refetch } = useQuery({
    queryKey: ['approverDetails', requestNo, revisionNo, isOpen],
    queryFn: () => fetchApproverDetails({ requestNo, revisionNo }),
    enabled: isParamsReady, // only fetch when modal is open
    onError: () => {
      toast.error('Failed to fetch approvers details', {
        className: 'toast-error',
      });
    },
  });

  useEffect(() => {
    if (isParamsReady) {
      refetch();
    }
  }, [requestNo, revisionNo, isOpen, refetch, isParamsReady]);

  const renderTableBody = () => {
    const tableData = data;
    // Ensure tableData is not undefined or null
    if (!tableData || Object.keys(tableData).length === 0) {
      if (isLoading) {
        return (
          <tr>
            <td className="text-center" colSpan={5}>
              Loading...
            </td>
          </tr>
        );
      }
      return (
        <tr>
          <td className="text-center" colSpan={5}>
            {Messages.NO_APPROVERS}
          </td>
        </tr>
      );
    }

    return tableData?.map((item, index) => (
      <tr key={index}>
        <td className="py-2">{index + 1}.</td>
        <td className="py-2">{item?.Approver ?? 'N/A'}</td>
        <td className="py-2">{item?.Status ?? 'N/A'}</td>
        <td className="py-2">
          {item['Approved Date']
            ? moment(item['Approved Date']).format('DD-MM-YYYY')
            : 'N/A'}
        </td>
        <td className="py-2">{item['Approved By'] ?? 'N/A'}</td>
      </tr>
    ));
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="xl">
      <div className="modal-header p-0">
        <div className="pt-3 pb-2 px-3 d-flex flex-row align-items-center justify-content-between w-100 mb-2">
          <div className="fw-semibold">Approvers Details</div>
          <button type="button" className="btn btn-link p-0" onClick={toggle}>
            <Icon path={mdiClose} size={0.8} />
          </button>
        </div>
      </div>
      <ModalBody className="p-3">
        <div
          className="table-responsive table-fix p-0"
          style={{
            border: '2px solid #D0D5DD',
            borderRadius: '8px',
          }}
        >
          <Table hover className="custom-table align-middle text-nowrap mb-0">
            <thead>
              <tr>
                <th>#</th>
                <th>Approver</th>
                <th>Status</th>
                <th>Date</th>
                <th>Approved By</th>
              </tr>
            </thead>
            <tbody>{renderTableBody()}</tbody>
          </Table>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default ViewApproversModal;
